<template>
  <div class="home-container">
    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 左侧菜单 -->
      <el-aside :width="isCollapsed ? '64px' : '200px'" class="sidebar">
        <!-- LOGO部分在左侧菜单顶部 -->
        <div class="sidebar-logo">
          <div class="logo">视频检查平台</div>
          <!-- 折叠状态下在LOGO位置显示折叠按钮 -->
          <el-button 
            v-if="isCollapsed" 
            class="collapse-btn " 
            type="text" 
            @click="toggleCollapse"
          >
            <el-icon><Expand /></el-icon>
          </el-button>
        </div>
        <el-menu
          :router="true"
          :default-active="$route.path"
          :collapse="isCollapsed"
          class="el-menu-vertical"
          background-color="white"
          text-color="#606266"
          active-text-color="#409EFF">
          <el-menu-item index="/dashboard">
            <el-icon><PieChart /></el-icon>
            <span>数据看板</span>
          </el-menu-item>
          <el-menu-item index="/monitor-result">
            <el-icon><Monitor /></el-icon>
            <span>监控结果</span>
          </el-menu-item>
          <!-- 积分充值菜单已隐藏 -->
          <!-- <el-menu-item index="/points-recharge">
            <el-icon><CreditCard /></el-icon>
            <span>积分充值</span>
          </el-menu-item> -->
        </el-menu>
      </el-aside>

      <!-- 右侧内容区 -->
      <div class="right-content">
        <!-- 顶部导航栏 -->
        <el-header class="header">
          <!-- 未折叠状态下在右侧顶部显示折叠按钮 -->
          <el-button 
            v-if="!isCollapsed" 
            class="collapse-btn" 
            type="text" 
            @click="toggleCollapse"
          >
            <el-icon><Fold /></el-icon>
          </el-button>
          <el-dropdown class="user-menu">
            <div class="user-info">
              <el-avatar :size="40" :src="user.avatar" />
              <span class="username">{{ user.nickname }}</span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="showResetPasswordDialog">修改密码</el-dropdown-item>
                <el-dropdown-item @click="showChangeMobileDialog">修改手机号</el-dropdown-item>
                <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-header>

   

        <!-- 主要内容区域 -->
        <el-main class="content">
          <router-view />
        </el-main>
      </div>
    </div>

    <!-- 修改密码对话框 -->
    <el-dialog
      v-model="resetPasswordDialogVisible"
      title="修改密码"
      width="420px"
      :before-close="closeResetPasswordDialog"
    >
      <el-form
        ref="resetPasswordFormRef"
        :model="resetPasswordForm"
        :rules="resetPasswordRules"
        label-width="110px"
      >
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="resetPasswordForm.newPassword"
            type="password"
            show-password
            placeholder="请输入新密码"
          />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model="resetPasswordForm.confirmPassword"
            type="password"
            show-password
            placeholder="请再次输入新密码"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closeResetPasswordDialog">取消</el-button>
        <el-button type="primary" :loading="resetPasswordLoading" @click="submitResetPassword">
          确定修改
        </el-button>
      </template>
    </el-dialog>

    <!-- 修改手机号对话框 -->
    <el-dialog
      v-model="changeMobileDialogVisible"
      title="修改手机号"
      width="460px"
      :before-close="closeChangeMobileDialog"
    >
      <el-form
        ref="changeMobileFormRef"
        :model="changeMobileForm"
        :rules="changeMobileRules"
        label-width="110px"
      >
        <el-form-item label="当前手机号">
          <el-input :model-value="maskedMobile" disabled />
        </el-form-item>
        <el-form-item label="验证旧手机号" prop="oldMobile">
          <el-input v-model="changeMobileForm.oldMobile" placeholder="请输入完整旧手机号" />
        </el-form-item>
        <el-form-item label="新手机号" prop="newMobile">
          <el-input v-model="changeMobileForm.newMobile" placeholder="请输入新手机号" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closeChangeMobileDialog">取消</el-button>
        <el-button type="primary" :loading="changeMobileLoading" @click="submitChangeMobile">
          确定修改
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { PieChart, Monitor, CreditCard, Fold, Expand } from '@element-plus/icons-vue'

export default {
  name: 'HomePage',
  components: {
    PieChart,
    Monitor,
    CreditCard,
    Fold,
    Expand
  },
  data() {
    const validatePasswordMatch = (rule, value, callback) => {
      if (value !== this.resetPasswordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      user: {
        nickname: '未登录',
        avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
      },
      isCollapsed: false,
      resetPasswordDialogVisible: false,
      changeMobileDialogVisible: false,
      resetPasswordLoading: false,
      changeMobileLoading: false,
      resetPasswordForm: {
        newPassword: '',
        confirmPassword: ''
      },
      changeMobileForm: {
        oldMobile: '',
        newMobile: ''
      },
      resetPasswordRules: {
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validatePasswordMatch, trigger: 'blur' }
        ]
      },
      changeMobileRules: {
        oldMobile: [
          { required: true, message: '请输入旧手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        newMobile: [
          { required: true, message: '请输入新手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    currentMobile() {
      return this.user?.mobile || this.user?.phone || ''
    },
    maskedMobile() {
      if (!this.currentMobile) return '未绑定'
      return this.currentMobile.replace(/(\d{3})\d{6}(\d{2})/, '$1******$2')
    }
  },
  watch: {
    '$store.getters.userInfo': {
      immediate: true,
      handler(newVal) {
        console.log('User info updated:', newVal)
        if (newVal) {
          this.user = newVal
        }
      }
    }
  },
 
  methods: {
    handleLogout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login').catch(() => {})
      })
    },
    showResetPasswordDialog() {
      this.resetPasswordDialogVisible = true
    },
    showChangeMobileDialog() {
      this.changeMobileDialogVisible = true
    },
    closeResetPasswordDialog() {
      this.resetPasswordDialogVisible = false
      this.resetPasswordForm = { newPassword: '', confirmPassword: '' }
      this.$refs.resetPasswordFormRef?.resetFields()
    },
    closeChangeMobileDialog() {
      this.changeMobileDialogVisible = false
      this.changeMobileForm = { oldMobile: '', newMobile: '' }
      this.$refs.changeMobileFormRef?.resetFields()
    },
    submitResetPassword() {
      this.$refs.resetPasswordFormRef.validate(async valid => {
        if (!valid) return
        this.resetPasswordLoading = true
        try {
          const response = await this.$axios.post('api/user/resetpwd', {
            newpassword: this.resetPasswordForm.newPassword
          })
          if (response.code === 0) {
            this.$message.error(response.msg || '修改密码失败')
            return
          }
          this.$message.success(response.msg || '密码修改成功，请重新登录')
          this.closeResetPasswordDialog()
          await this.$store.dispatch('logout')
          this.$router.push('/login').catch(() => {})
        } catch (error) {
          this.$message.error(error?.data?.msg || '修改密码失败')
        } finally {
          this.resetPasswordLoading = false
        }
      })
    },
    submitChangeMobile() {
      this.$refs.changeMobileFormRef.validate(async valid => {
        if (!valid) return
        if (this.currentMobile && this.changeMobileForm.oldMobile !== this.currentMobile) {
          this.$message.error('旧手机号验证失败')
          return
        }
        this.changeMobileLoading = true
        try {
          const response = await this.$axios.post('api/user/changemobile', {
            mobile: this.changeMobileForm.newMobile
          })
          if (response.code === 0) {
            this.$message.error(response.msg || '修改手机号失败')
            return
          }
          const updatedUser = {
            ...this.user,
            mobile: this.changeMobileForm.newMobile,
            phone: this.changeMobileForm.newMobile
          }
          this.$store.dispatch('setUserInfo', updatedUser)
          this.$message.success(response.msg || '手机号修改成功，请重新登录')
          this.closeChangeMobileDialog()
          await this.$store.dispatch('logout')
          this.$router.push('/login').catch(() => {})
        } catch (error) {
          this.$message.error(error?.data?.msg || '修改手机号失败')
        } finally {
          this.changeMobileLoading = false
        }
      })
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
    getCurrentPageName() {
      const routeMap = {
        '/dashboard': '数据看板',
        '/monitor-result': '监控结果',
        '/points-recharge': '积分充值'
      }
      return routeMap[this.$route.path] || '未知页面'
    }
  }
}
</script>

<style scoped>
.home-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar {
  background-color: white;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e4e7ed;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);
}

.sidebar-logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
  font-weight: bold;
}

.logo {
  font-size: 18px;
  font-weight: bold;
}

.el-menu-vertical {
  border-right: none;
}

.el-menu-vertical .el-menu-item {
  height: 56px;
  line-height: 56px;
  color: #303133;
  font-weight: normal;
  margin: 4px 8px;
  border-radius: 6px;
}

.el-menu-vertical .el-menu-item:hover {
  background-color: #f5f7fa;
  color: #409EFF;
}

.el-menu-vertical .el-menu-item.is-active {
  background-color: #409EFF;
  color: white !important;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  border-radius: 8px;
}

/* 确保选中状态的图标也是白色 */
.el-menu-vertical .el-menu-item.is-active .el-icon {
  color: white !important;
}

/* 折叠状态下图标居中 */
.el-menu-vertical:not(.el-menu--collapse) .el-menu-item .el-icon {
  margin-right: 8px;
}

.el-menu-vertical.el-menu--collapse .el-menu-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-menu-vertical.el-menu--collapse .el-menu-item .el-icon {
  margin-right: 0;
}

.right-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  background-color: #f0f2f5;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  color: #606266;
  padding: 0 24px;
  height: 64px;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.collapse-btn {
  font-size: 18px;
  color: #606266;
  border: none;
  background: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.collapse-btn:hover {
  background-color: #f0f2f5;
}

.user-menu {
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.3s;
}

.user-info:hover {
  background-color: #f5f7fa;
}

.username {
  font-size: 14px;
  color: #303133;
}

/* 彻底移除头像和下拉菜单的所有边框 */
:deep(.el-avatar) {
  border: none !important;
}

:deep(.el-dropdown__popper .el-dropdown-menu__item) {
  border: none !important;
}

:deep(.el-dropdown) {
  border: none !important;
}

:deep(.el-dropdown .el-dropdown-selfdefine) {
  border: none !important;
  outline: none !important;
}

:deep(.el-dropdown .el-dropdown-selfdefine:focus) {
  border: none !important;
  outline: none !important;
}

:deep(.el-dropdown .el-dropdown-selfdefine:hover) {
  border: none !important;
  outline: none !important;
}

/* 移除用户信息区域的边框 */
.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.3s;
  border: none !important;
  outline: none !important;
}

.user-info:hover {
  background-color: #f5f7fa;
  border: none !important;
  outline: none !important;
}

.content {
  padding: 24px;
  background-color: white;
  flex: 1;
  overflow: auto;
  margin: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 面包屑容器样式 */
.breadcrumb-container {
  margin: 0 16px;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
</style>
